import { Component } from '@angular/core';
import { FileWidget as _FileWidget } from '../angular2-schema-form-shim';
import { JSONSchema } from '../types/json-schema';
import { isWidgetRequired } from './overrides';

@Component( {
  selector: 'sp-file-widget',
  templateUrl: './file.widget.html',
} )
export class FileWidget extends _FileWidget {
  schema: JSONSchema;
  protected reader: FileReader;
  protected filedata: { [ key: string ]: any };

  get required() {
    return isWidgetRequired( this );
  }
}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/file.widget.ts